module.exports = __webpack_public_path__ + "static/media/paused.17054f63.svg";